// Shared helpers for the Add Offer wizard step pages.
// Provides a thin wrapper around this.$apiFetch with the client API base URL
// and auth headers so the step pages stay focused on their own concerns.

const BYOO = '/private/api/client/bring-your-own-offer'

export const wizardApi = {
  methods: {
    $api_base() {
      return localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL
    },
    $api_token() {
      return localStorage.getItem('token')
    },
    async $api(path, { method = 'GET', body, isForm = false } = {}) {
      const headers = { Authorization: `${this.$api_token()}` }
      if (!isForm) headers['Content-Type'] = 'application/json'
      const response = await this.$apiFetch(`${this.$api_base()}${path}`, {
        method,
        headers,
        body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
      })
      if (!response.ok) {
        const text = await response.text().catch(() => '')
        throw new Error(text || `Request failed (${response.status})`)
      }
      const contentType = response.headers.get('content-type') || ''
      return contentType.includes('application/json') ? response.json() : null
    },
    byooPath(suffix) {
      return `${BYOO}${suffix}`
    },
  },
}
